import React from 'react';
import { Service_list } from '../data/Service_List';
import style from '../css/Services.module.css';
import Two from '../components/Two';
import Five from '../components/Five';
import Shower from '../components/Shower';
import Footer from '../components/Footer';

function Services() {
	return (
		<div>
			<p className={style.list}>List Of Our Services</p>
			<div className={style.container}>
				{Service_list.map((service, index) => (
					<div key={service.id} className={style.container1}>
						<img
							src={service.img}
							alt={service.title}
							className={style.image}
						/>
						<div className={style.text_box}>
							<h2 className={style.title}>{service.title}</h2>
							<p className={style.desc}>{service.desc}</p>
						</div>
					</div>
				))}
			</div>

			<Shower />
			<Two />
			<Five />
			<Footer />
		</div>
	);
}

export default Services;
